<form class="form" [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
  <app-scroll-view class="scroll-view">
    <div class="fields-container">
      <div class="field-set">
        <ng-template
          [ngTemplateOutlet]="pinCtrlTpl"
          [ngTemplateOutletContext]="aPinCtrlContext"
        ></ng-template>
      </div>
      <div class="field-set">
        <ng-template
          [ngTemplateOutlet]="pinCtrlTpl"
          [ngTemplateOutletContext]="bPinCtrlContext"
        ></ng-template>
      </div>
      <div class="field-set">
        <label label>Única entidade</label>

        <app-radio-group
          formControlName="uniqueEntity"
          [items]="yesOrNotList"
          displayExpr="label"
          valueExpr="value"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-radio-group>
      </div>
      <div class="field-set">
        <label label>Descontinuidade</label>

        <app-select-box
          formControlName="maxDistance"
          [items]="maxDistanceList"
          displayExpr="label"
          valueExpr="value"
          [showErrorEnabled]="false"
          [showClearButton]="false"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-select-box>
      </div>

      <div class="field-set">
        <div
          class="btn-item"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        >
          <app-button
            buttonType="primary"
            styleType="contained"
            [text]="
              (drawPathActiveObservable | async)
                ? 'Cancelar desenho'
                : 'Desenhar trajeto'
            "
            (click)="onBtnDrawPathClick()"
            width="100%"
          ></app-button>
        </div>
      </div>
    </div>

    <div class="path-list-container" #pathListContainerEl>
      <app-list [items]="pathList" [scrollable]="false">
        <ng-template listItem let-item="item">
          <div
            class="path-item"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
            <app-button
              buttonType="normal"
              styleType="text"
              shapeType="circle"
              sizeType="small"
              icon="assets/icons/location-arrow.svg"
              (click)="onBtnShowPathClick(item)"
            ></app-button>

            <div class="text">
              {{ item.text }}
            </div>
          </div>
        </ng-template>
      </app-list>
    </div>
  </app-scroll-view>

  <div class="actions-bottom">
    <div
      class="btn-item"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    >
      <app-button
        type="submit"
        buttonType="primary"
        styleType="contained"
        text="Calcular"
        width="10rem"
      ></app-button>
    </div>
    <div
      class="btn-item"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    >
      <app-button
        buttonType="normal"
        styleType="contained"
        text="Limpar"
        (click)="onBtnClearClick()"
        width="10rem"
      ></app-button>
    </div>
  </div>
</form>

<ng-template
  #pinCtrlTpl
  let-pinUrlObservable="pinUrlObservable"
  let-pointValueObservable="pointValueObservable"
  let-activeObservable="activeObservable"
  let-placeholder="placeholder"
  let-onPinClick="onPinClick"
>
  <div class="pin-ctrl" [ngClass]="{ active: activeObservable | async }">
    <img
      class="btn-pin"
      [src]="pinUrlObservable | async"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
      (click)="onPinClick?.()"
    />

    <app-input-box
      [value]="pointValueObservable | async"
      [placeholder]="placeholder"
      [readOnly]="true"
      [showErrorEnabled]="false"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    ></app-input-box>
  </div>
</ng-template>

<app-loading-panel
  [visible]="loadingController.changes | async"
  [container]="pathListContainerEl"
  [overlayMask]="false"
  modalVerticalAlignment="top"
  containerVerticalAlignment="top"
></app-loading-panel>
